import React from 'react';
import './FooterNav.css';

const FooterNav = () => (
  <footer className="site-footer">
    <div className="footer-content">
      <div className="footer-section">
        <h4>Support</h4>
        <a href="/help">Help Center</a>
        <a href="/safety">Safety Information</a>
        <a href="/accessibility">Accessibility</a>
        <a href="/report">Report a concern</a>
      </div>
      <div className="footer-section">
        <h4>Community</h4>
        <a href="/blog">Blog</a>
        <a href="/invite">Invite friends</a>
        <a href="/host">Become a host</a>
        <a href="/forum">Parent forum</a>
      </div>
      <div className="footer-section">
        <h4>About</h4>
        <a href="/about">About us</a>
        <a href="/careers">Careers</a>
        <a href="/press">Press</a>
        <a href="/contact">Contact</a>
      </div>
      <div className="footer-section">
        <h4>Legal</h4>
        <a href="/privacy">Privacy Policy</a>
        <a href="/terms">Terms of Service</a>
        <a href="/cookies">Cookie Policy</a>
      </div>
    </div>
    <div className="footer-bottom">
      <p>© 2026 BabyOnTheGo. All rights reserved.</p>
      <div className="footer-socials">
        <a href="#" title="Facebook">📘</a>
        <a href="#" title="Instagram">📷</a>
        <a href="#" title="Twitter">🐦</a>
      </div>
    </div>
  </footer>
);

export default FooterNav;
